const MASQUERADE_KEY = 'masquerade_org_id';

export const masqueradeUtils = {
  activate(organizationId) {
    sessionStorage.setItem(MASQUERADE_KEY, organizationId);
  },

  deactivate() {
    sessionStorage.removeItem(MASQUERADE_KEY);
  },

  getOrgId() {
    return sessionStorage.getItem(MASQUERADE_KEY);
  },

  isActive() {
    return !!sessionStorage.getItem(MASQUERADE_KEY);
  }
};
